import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SubscriptionHistoryListItemLoadingDesktop } from './Desktop';
import { SubscriptionHistoryListItemLoadingMobile } from './Mobile';
import { SubscriptionHistoryListItemLoadingTablet } from './Tablet';

export const SubscriptionHistoryListItemLoading: React.FC = (props) => {
  const responsiveItem = useBreakpointValue({
    base: <SubscriptionHistoryListItemLoadingMobile {...props} />,
    sm: <SubscriptionHistoryListItemLoadingTablet {...props} />,
    lg: <SubscriptionHistoryListItemLoadingDesktop {...props} />,
  });

  return responsiveItem;
};
